import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Main.scss';
import { useTranslation } from 'react-i18next';
import profilepic from '../assets/images/profilepic.png';

function Main() {
    const {t} = useTranslation();
  return (
    <div className="container">      
      <div className="about-section">
        <div className="image-wrapper">
          <img src={profilepic} alt="Avatar" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/Falco830" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/alecmichel/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
          <h1>{t('aboutName')}</h1>
          <p>{t('aboutTitle')}</p>

          <div className="mobile_social_icons">
            <a href="https://github.com/Falco830" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/alecmichel/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;